module.exports = __webpack_public_path__ + "img/btn_liver_on.280f799f.svg";